import URLS from '@/server/urls';
import { GET } from '@/server/http';

export default async (params, options = { showError: true }) => {
    const [ content, error, status ] = await GET(URLS.user.currentUser, { ...params }, options);
    if (error) return { error, status };
    return content || {};
};

